import { apiClient } from '../apiClient';

export const fetchTradeSegmentOptions = async () => {
  try {
    const response = await apiClient.get('/pmiDevices/trade-segments/unique');
    return response.data;
  } catch (error) {
    console.error('Error fetching tradeSegment options:', error);
    throw error;
  }
};

export const fetchPosTypetOptions = async () => {
  try {
    const response = await apiClient.get('/pmiDevices/pos-types/unique');
    return response.data;
  } catch (error) {
    console.error('Error fetching pos-types options:', error);
    throw error;
  }
};

export const fetchKaNameOptions = async () => {
  try {
    const response = await apiClient.get('/pmiDevices/kaName/unique');
    return response.data;
  } catch (error) {
    console.error('Error fetching KA Name options:', error);
    throw error;
  }
};

export const fetchMannedOptions = async () => {
  const response = await apiClient.get('/pmiDevices/manned/unique');
  return response.data;
};

export const fetchPlacementOptions = async () => {
  const response = await apiClient.get('/pmiDevices/placements/unique');
  return response.data;
};

export const fetchTireOptions = async () => {
  const response = await apiClient.get('/pmiDevices/tire/unique');
  return response.data;
};

export const fetchScreeTypeOptions = async () => {
  const response = await apiClient.get('/pmiDevices/screenType/unique');
  return response.data;
};

export const fetchisActiveOptions = async () => {
  const response = await apiClient.get('/pmiDevices/isActive/unique');
  return response.data;
};

export const fetchRegionOptions = async () => {
  const response = await apiClient.get('/pmiDevices/region/unique');
  return response.data;
};

export const fetchTalActualOptions = async () => {
  const response = await apiClient.get('/pmiDevices/talActual/unique');
  return response.data;
};

export const fetchTaActualOptions = async () => {
  const response = await apiClient.get('/pmiDevices/taActual/unique');
  return response.data;
};

export const fetchCityOptions = async () => {
  const response = await apiClient.get('/pmiDevices/city/unique');
  return response.data;
};

export const fetchSeasonality = async () => {
  const response = await apiClient.get('/pmiDevices/seasonality/unique');
  return response.data;
};

export const fetchStpOptions = async () => {
  const response = await apiClient.get('/pmiDevices/stp/unique');
  return response.data;
};
